import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const CheckToken = ({ setIsLoggedIn }) => {
  const [countdown, setCountdown] = useState(null);
  const navigate = useNavigate();
  

  useEffect(() => {
    const checkToken = () => {
      const token = localStorage.getItem('token');
      const isLoggedIn = localStorage.getItem('isLoggedIn');
      if (isLoggedIn) {
        if (token) {
          try {
            const decodedToken = jwtDecode(token);
            const expirationTime = decodedToken.exp * 1000;
            const currentTime = Date.now();

            // Check if the token has expired
            if (currentTime >= expirationTime) {
              localStorage.clear();
              localStorage.clear();
              // setIsLoggedIn(false);
              alert('Session has been Expired! Login Again');
              navigate('/');
            } else {
              // Token is valid, check how much time is left
              const timeLeft = expirationTime - currentTime;

              // If less than or equal to 5 seconds, start the countdown
              if (timeLeft <= 5000) {
                setCountdown(Math.ceil(timeLeft / 1000));
                const countdownInterval = setInterval(() => {
                  setCountdown((prevCountdown) => {
                    if (prevCountdown <= 1) {
                      clearInterval(countdownInterval);
                      localStorage.clear();
                      localStorage.clear();
                      // setIsLoggedIn(false);
                      alert('Session expired, logging out...');
                      navigate('/');
                    }
                    return prevCountdown - 1;
                  });
                }, 1000);
              } else {
                setCountdown(null);
              }
              // setIsLoggedIn(true);
            }
          } catch (error) {
            // setIsLoggedIn(false);
          }
        } else {
          // setIsLoggedIn(false);
        }
      }
    };

    checkToken(); // Initial token check
    const tokenCheckInterval = setInterval(checkToken, 5000); // Check every 5 seconds

    // Cleanup the interval on component unmount
    return () => {
      clearInterval(tokenCheckInterval);
    };
  }, [setIsLoggedIn, navigate]);

  return (
    <>
      {countdown !== null && countdown <= 5 && (
        <div className="countdown-popup">
          <p>Your session will expire in {countdown} second{countdown > 1 ? 's' : ''}.</p>
        </div>
      )}
    </>
  );
};

export default CheckToken;
